var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VIDEO_STATE } from '../enums';
import { commonTool, Logger } from '../util';
/** guid随机串的长度 */
var GUID_LEN = 8;
/**
 * 一个url地址对应的播放对象
 * @class
 */
var VideoInfo = /** @class */ (function () {
    /**
     * 视频信息。在播放列表中，每个播放节点都对应一个视频信息。
     */
    function VideoInfo(opts, playerConfig) {
        this.playtime = 0;
        this.currentAudioTrack = NaN;
        this.duration = 0;
        this.performance = {};
        this.startTime = 0;
        this.state = VIDEO_STATE.IDLE;
        this.fileSize = 0;
        this.videoWidth = 0;
        this.videoHeight = 0;
        this.hasFirstPlaying = false;
        this.startPts = 0;
        this.discontinuityTimeRanges = [];
        this.videoFrameRate = 0;
        this.audioTracks = [];
        this.currentLevelIndex = -1;
        this.levels = [];
        this.currentLevel = null;
        this.isAutoLevel = false;
        this.stateWhenErrorHappen = null;
        this.logger = new Logger(playerConfig.instanceId, 'VideoInfo');
        this.extraVarsInner = {};
        this.qualityInfoInner = {};
        this.uidInner = commonTool.createGUID(GUID_LEN);
        this.configInner = opts;
        this.playerConfigInner = playerConfig;
        this.codecs = this.configInner.codec ? __assign({}, this.configInner.codec) : { video: '', audio: '' };
        this.reset();
        this.logger.log("new VideoInfo(), uid: ".concat(this.uid));
    }
    VideoInfo.prototype.toJSON = function () {
        return this.serializedString();
    };
    VideoInfo.prototype.toString = function () {
        return this.serializedString();
    };
    Object.defineProperty(VideoInfo.prototype, "config", {
        get: function () {
            return this.configInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "qualityInfo", {
        get: function () {
            return this.qualityInfoInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "uid", {
        get: function () {
            return this.uidInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "loadingUrl", {
        get: function () {
            return this.loadingUrlInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "extraVars", {
        get: function () {
            return this.extraVarsInner;
        },
        enumerable: false,
        configurable: true
    });
    VideoInfo.prototype.reset = function () {
        // 重置地址索引
        this.nextBackUrlIdxInner = 0;
        // 重置重试次数限制
        this.retryCountInner = 0;
        this.performance = {};
        // 先使用传入的url开始加载，后续可能会换成备份地址列表中的地址
        this.loadingUrlInner = this.configInner.url;
        // reset的时候同时清理音轨信息
        this.audioTracks = [];
    };
    VideoInfo.prototype.setLoadingUrlStartTime = function (startTime) {
        if (this.loadingUrlInner && startTime > 0) {
            this.loadingUrlInner = "".concat(this.loadingUrlInner.split('#t=')[0], "#t=").concat(startTime);
        }
    };
    VideoInfo.prototype.setDependVideoInfo = function (preVideoInfo) {
        this.startTime = preVideoInfo ? (preVideoInfo.startTime + preVideoInfo.duration) : 0;
        this.logger.log("setDependVideoInfo succ, uid/starttime: ".concat(this.uid, "/").concat(this.startTime));
        return true;
    };
    /**
     * 切换下一个备用地址，备用地址上限次数为defaultPlayerConfig.backupUrlsMaxRetryCount配置，如果备用地址没有或者不够会循环到第一个
     * （注意是重试次数，比如请求1次重试3次备用地址，一共就会有4次请求）
     */
    VideoInfo.prototype.setNextBackUrl = function () {
        if (!this.configInner.url || this.retryCountInner >= this.playerConfigInner.backupUrlsMaxRetryCount)
            return false;
        this.retryCountInner++;
        if (this.configInner.backupUrls && this.configInner.backupUrls.length > 0) {
            if (this.nextBackUrlIdxInner >= this.configInner.backupUrls.length) {
                this.loadingUrlInner = this.configInner.url;
                this.nextBackUrlIdxInner = 0;
            }
            else {
                this.loadingUrlInner = this.configInner.backupUrls[this.nextBackUrlIdxInner];
                this.nextBackUrlIdxInner++;
            }
        }
        else {
            this.loadingUrlInner = this.configInner.url;
        }
        return true;
    };
    VideoInfo.prototype.getRetryCount = function () {
        return this.retryCountInner;
    };
    /**
     * videoinfo销毁（需要注意的是，作为信息载体，很多信息在销毁后不需要清空，因为播放器或者引用方仍然需要知道）
     */
    VideoInfo.prototype.destroy = function () {
        this.extraVarsInner = null;
    };
    VideoInfo.prototype.serializedString = function () {
        var _a, _b;
        return "VideoInfo{u:".concat(this.loadingUrlInner, ",t:").concat(this.playtime, ",s:").concat(this.state, ",ec:").concat(((_a = this.error) === null || _a === void 0 ? void 0 : _a.code) || '', ",em:").concat(((_b = this.error) === null || _b === void 0 ? void 0 : _b.message) || '', ",r:").concat(this.nextBackUrlIdxInner, "}");
    };
    return VideoInfo;
}());
export default VideoInfo;
